import { render, staticRenderFns } from "./character.vue?vue&type=template&id=7c6e42e8&scoped=true&"
import script from "./character.vue?vue&type=script&lang=js&"
export * from "./character.vue?vue&type=script&lang=js&"
import style0 from "./character.vue?vue&type=style&index=0&id=7c6e42e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6e42e8",
  null
  
)

export default component.exports